import { render, staticRenderFns } from "./StrenghtSelection.vue?vue&type=template&id=0ac2f6e8&scoped=true"
import script from "./StrenghtSelection.vue?vue&type=script&lang=js"
export * from "./StrenghtSelection.vue?vue&type=script&lang=js"
import style0 from "./StrenghtSelection.vue?vue&type=style&index=0&id=0ac2f6e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac2f6e8",
  null
  
)

export default component.exports